export default __webpack_public_path__ + "static/ibm_cloud-429e3ac6bb3a6a0d8ab5cd02888e47e0.svg";